import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { LAUNCHER } from "./nav";
import { useWorkspace } from "./WorkspaceContext";

export const AppLauncher = ({ open, onOpenChange }) => {
  const [q, setQ] = useState("");
  const { can } = useWorkspace();
  const navigate = useNavigate();
  const groups = LAUNCHER.map((g) => ({
    ...g,
    items: g.items.filter((i) => can(i.roles) && i.label.toLowerCase().includes(q.toLowerCase())),
  })).filter((g) => g.items.length);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto" data-testid="app-launcher-panel">
        <SheetHeader><SheetTitle className="font-heading">All apps</SheetTitle></SheetHeader>
        <div className="relative mt-4 mb-6">
          <Search className="h-4 w-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search apps" autoFocus
            className="w-full h-10 pl-9 pr-3 rounded-lg border border-slate-200 text-sm focus:outline-none focus:border-slate-400" data-testid="launcher-search-input" />
        </div>
        {groups.length === 0 && <p className="text-sm text-slate-500">No apps match "{q}".</p>}
        {groups.map((g) => (
          <div key={g.group} className="mb-6">
            <p className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-2">{g.group}</p>
            <div className="grid grid-cols-3 gap-2">
              {g.items.map((i) => (
                <button
                  key={i.path}
                  onClick={() => { onOpenChange(false); navigate(i.path); }}
                  className="flex flex-col items-center gap-2 rounded-xl p-3 hover:bg-slate-50 border border-transparent hover:border-slate-200 transition-colors"
                  data-testid={`launcher-item-${i.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <span className="h-10 w-10 rounded-xl bg-[#0B1530]/[0.06] text-[#0B1530] flex items-center justify-center"><i.icon className="h-5 w-5" /></span>
                  <span className="text-xs text-slate-700 text-center leading-tight">{i.label}</span>
                  {i.phase2 && <span className="text-[9px] uppercase tracking-wide text-slate-400 -mt-1">Phase 2</span>}
                </button>
              ))}
            </div>
          </div>
        ))}
      </SheetContent>
    </Sheet>
  );
};
